import styled from "styled-components"

export const FillViewportView = styled.div`
  width: 100%;
  height: 100svh;

  /*
   * Create a new stacking context at the root of the app. The reason we do this is that
   * popover elements are typically inserted at the end of the body and are intended to
   * sit over top of all other content. However these will compete with z-indexes that
   * are set inside this container which is not what we want. By creating an isolated
   * stacking context here we can use z-indexes internally within the app-container and
   * popover content will still behave correctly.
   */
  isolation: isolate;
`
